import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobSiteJobMinuteActions'
import * as api from '../../api/job/jobSiteJobMinutes'
import * as templateApi from '../../api/template'

function* jobSiteJobMinutesRefresh(action) {
  try {
    const payload = yield call(api.getJobSiteJobMinutes, action.jobId)
    yield put({ type: constants.JOB_SITE_JOB_MINUTES_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_JOB_MINUTES_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobSiteJobMinutes() {
  yield takeLatest(constants.JOB_SITE_JOB_MINUTES_REFRESH.ACTION, jobSiteJobMinutesRefresh)
}

function* sagaCreateJobSiteJobMinute(action) {
  try {
    const payload = {
      job_minute_data: {
        job_id: action.jobId,
        attendees: action.content.attendees,
        subject: action.content.subject,
        body: action.body
      },
      created_by_id: action.userId,
      updated_by_id: action.userId
    }

    if (action.content.job_minute_template_id !== '')
      payload.job_minute_data.job_minute_template_id = action.content.job_minute_template_id
    yield call(api.createJobMinute, payload)
    yield put({ type: constants.JOB_SITE_JOB_MINUTE_CREATE.SUCCESS, payload })
    yield call(jobSiteJobMinutesRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_JOB_MINUTE_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobSiteJobMinute() {
  yield takeLatest(constants.JOB_SITE_JOB_MINUTE_CREATE.ACTION, sagaCreateJobSiteJobMinute)
}

function* sagaUpdateJobSiteJobMinute(action) {
  try {
    const payload = {
      job_minute_id: action.jobMinuteId,
      job_minute_data: {
        job_id: action.jobId,
        attendees: action.content.attendees,
        subject: action.content.subject,
        body: action.body
      },
      updated_by_id: action.userId
    }
    yield call(api.updateJobMinute, payload)
    yield put({ type: constants.JOB_SITE_JOB_MINUTE_UPDATE.SUCCESS, payload })
    yield call(jobSiteJobMinutesRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_JOB_MINUTE_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobSiteJobMinute() {
  yield takeLatest(constants.JOB_SITE_JOB_MINUTE_UPDATE.ACTION, sagaUpdateJobSiteJobMinute)
}

function* sagaDeleteJobSiteJobMinute(action) {
  try {
    const payload = {
      job_minute_id: action.jobMinuteId
    }
    yield call(api.deleteJobMinute, payload)
    yield put({ type: constants.JOB_SITE_JOB_MINUTE_DELETE.SUCCESS, payload })
    yield call(jobSiteJobMinutesRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_JOB_MINUTE_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobSiteJobMinute() {
  yield takeLatest(constants.JOB_SITE_JOB_MINUTE_DELETE.ACTION, sagaDeleteJobSiteJobMinute)
}

function* getJobMinuteTemplates(action) {
  try {
    const payload = yield call(templateApi.getJobMinuteTemplates)
    yield put({ type: constants.GET_JOB_MINUTE_TEMPLATES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_JOB_MINUTE_TEMPLATES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetJobMinuteTemplates() {
  yield takeLatest(constants.GET_JOB_MINUTE_TEMPLATES.ACTION, getJobMinuteTemplates)
}

// ATTACHMENT SAGAS
function* uploadAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      jobMinuteId: action.jobMinuteId
    }

    yield call(api.uploadAttachments, payload)
    yield put({ type: constants.UPLOAD_JOB_MINUTE_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { jobMinuteId: action.jobMinuteId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_JOB_MINUTE_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadAttachments() {
  yield takeLatest(constants.UPLOAD_JOB_MINUTE_ATTACHMENT.ACTION, uploadAttachments)
}

function* getAttachments(action) {
  try {
    const payload = yield call(api.getAttachments, action.jobMinuteId)
    yield put({ type: constants.GET_JOB_MINUTE_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_JOB_MINUTE_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAttachments() {
  yield takeLatest(constants.GET_JOB_MINUTE_ATTACHMENTS.ACTION, getAttachments)
}

function* updateAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: 1,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_JOB_MINUTE_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getAttachments, { jobMinuteId: action.jobMinuteId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_JOB_MINUTE_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_JOB_MINUTE_ATTACHMENT_DESCRIPTION.ACTION,
    updateAttachmentDescription
  )
}

function* deleteAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      jobMinuteId: action.jobMinuteId
    }

    yield call(api.deleteAttachment, payload)
    yield put({ type: constants.DELETE_JOB_MINUTE_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { jobMinuteId: action.jobMinuteId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_JOB_MINUTE_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAttachments() {
  yield takeLatest(constants.DELETE_JOB_MINUTE_ATTACHMENT.ACTION, deleteAttachment)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobSiteJobMinutes),

    fork(watchCreateJobSiteJobMinute),
    fork(watchUpdateJobSiteJobMinute),
    fork(watchDeleteJobSiteJobMinute),
    fork(watchGetJobMinuteTemplates),

    fork(watchUploadAttachments),
    fork(watchGetAttachments),
    fork(watchUpdateAttachmentDescription),
    fork(watchDeleteAttachments)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobSiteJobMinuteSaga.js